<template>
   <div class="containerNcm">   
    <div class="painel2">
      <img src="/arqlef/arqlef2.svg" alt="" />
    </div>
    <div class="OpCadList">
      <p class="txtOpCadList">O que você deseja?</p> 
      <div style="display: flex;justify-content: center;">
        <div class="cad" style="margin-right:40px;" @click="novaEmpresa()">
            <img src="/arqlef/grupo1.svg" alt="" /><br>
            <p>Cadastrar nova empresa</p>
        </div>
        <div class="cad" style="margin-left:40px;" @click="listaEmpresa()">
          <img src="/arqlef/grupo2.svg" alt="" /><br>
          <p>Consultar empresas cadastradas</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods:{
    listaEmpresa(){
     this.$router.push({
        name: "empresas",
      });
    },
    novaEmpresa(){
      this.$router.push({
        name: "cadastrarempresa",
      });
    }
  },
  created(){
    document.documentElement.scrollTop = 0;
  }
}
</script>

<style>
.OpCadList{
  padding-bottom: 125px;
}
.txtOpCadList{
   color: #000;
  font-size: 1.8em;
  font-weight: bold;
  margin-top: 100px;
  margin-bottom: 75px;
  text-align: center;
}
.cad{
  width: 270px;
  height: 260px;
  background: #009188;
  border-radius: 5px;
  cursor: pointer;
  color:#fff;
  padding:30px;
}
.cad:hover{
   background: #01746c;
   
}
.cad p{
  font-size: 22px;
  margin-top:20px;
}
</style>